// extracted by mini-css-extract-plugin
export var container = "_r5-0";
export var dotAnimation = "_r5-2";
export var dotsLoading = "_r5-1";